import React, { useState, useEffect } from 'react';
import Toast from './Toast';

interface ToastItem {
  id: string;
  title: string;
  message: string;
  type: 'success' | 'error' | 'info';
  url?: string;
}

const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    // Escuchar el evento personalizado para mostrar toasts
    const handleShowToast = (event: CustomEvent<{ title: string; message: string; type: string; url?: string }>) => {
      const { title, message, type, url } = event.detail;
      
      // Crear un nuevo toast con ID único
      const newToast: ToastItem = {
        id: `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        title,
        message,
        type: (type as 'success' | 'error' | 'info') || 'info',
        url
      };
      
      setToasts(prevToasts => [...prevToasts, newToast]);
    };

    // Añadir el event listener
    window.addEventListener('showToast' as any, handleShowToast as EventListener);

    // Limpiar el event listener al desmontar
    return () => {
      window.removeEventListener('showToast' as any, handleShowToast as EventListener);
    };
  }, []);

  const removeToast = (id: string) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  };

  return (
    <div className="fixed top-0 right-0 p-4 z-50 space-y-4 max-h-screen overflow-hidden pointer-events-none">
      {toasts.map(toast => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            title={toast.title}
            message={toast.message}
            type={toast.type}
            onClose={() => removeToast(toast.id)}
            url={toast.url}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
